/* eslint-disable */
import Header from "components/Common/Header/Header";
import ProjectDetailBody from "components/ProjectManagementComponents/ProjectDetailsComponents/ProjectDetailComponents/ProjectDetailBody/ProjectDetailBody";
import React, { useEffect } from "react";

const ProjectDetail = () => {
  // -------- for title ------------
  useEffect(() => {
    document.title = "Project Management";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="projects" />

      {/* ------ body section -------- */}
      <ProjectDetailBody />
    </main>
  );
};

export default ProjectDetail;
